import React, { useState, useEffect } from "react";

import {
    Box,
    Grid,
    Button,
    Card,
    styled,
    Divider,
} from '@mui/material';

import { useNavigate } from "react-router-dom";

import { useReportContext } from "../../../context/ReportContext";
import { useReportDeliveryOrderItemExcelExport } from "../../../hooks/reports/sales/useReportDeliveryOrderItemExcelExport";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';

import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import { ReportBasicFilters, ReportAdvancedFilters } from "../filters/ReportFilters";
import { BasicFilter, AdvancedFilter } from "../filters/sales/FilterDeliveryOrderItem";


const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const RenderFormSearch = () => {

    const {
        t,
        formik,
        RenderToolbar,
        handleExport
    } = useReportContext()

    const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;
    const { generateExcel } = useReportDeliveryOrderItemExcelExport();
    const excelFileName = 'Delivery Order Items.xlsx';
    const processHandleExport = async () => handleExport({ formik, generateExcel, excelFileName });

    return (
          <Box>
              <form onSubmit={handleSubmit}>
                  <StyledCard>
                      <Grid container spacing={0}>

                          <Grid item xs={12} sm={12} md={5.5}>
                              <ReportBasicFilters>
                                  <BasicFilter/>
                              </ReportBasicFilters>
                          </Grid>

                          <Grid item xs={0} sm={0} md={0.5} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                              <Divider orientation="vertical"/>
                          </Grid>

                          <Grid item xs={12} sm={12} md={6}>
                              <ReportAdvancedFilters>
                                  <AdvancedFilter/>
                              </ReportAdvancedFilters>
                          </Grid>

                      </Grid>
                  </StyledCard>

                  <RenderToolbar
                        handleExport={processHandleExport}
                  />

              </form>
          </Box>
    )
}

const RenderBreadcumbs = ({
    navigate
}) => {

    const { t, availableReports, getRoute, routeType, availableReportScope } = useReportContext()

    let actionMenus = []

    Object.keys(availableReports).forEach(i => {

        let item = availableReports[i]

        actionMenus.push({
            displayText: t(item.display),
            onClick: () => {
                navigate(getRoute(`reports/${availableReportScope}/${item.id}`))
            }
        })
    })

    return (
          <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("deliveryOrderItemReport")}
                actionMenus={actionMenus}
                breadcrumbs={[
                    {
                        displayText: t("reports"),
                        props: {
                            // underline: "hover",
                            // href: getRoute('documents/cashSales')
                        }
                    },
                    {
                        displayText: t("deliveryOrderItemReport"),
                        props: {
                            // disabled: true,
                            color: 'secondary.main',
                        }
                    },
                ]}
          />
    )
}

const RenderReportDataDisplay = () => {

    const {
        t,
        RenderReportData
    } = useReportContext()

    const columns = [
        // { field: 'location_name', headerName: 'Location', flex: 1 },
        { field: 'no', headerName: t('number'), flex: 0.3 },
        { field: 'doc_number', headerName: t('docNo'), flex: 1 },
        { field: 'doc_date', headerName: t('docDate'), flex: 1 },
        { field: 'item_name', headerName: t('itemName'), flex: 1 },
        { field: 'code', headerName: t('code'), flex: 1 },
        { field: 'description', headerName: t('description'), flex: 1.2 },
        { field: 'uom_price', headerName: t('price'), flex: 0.7 },
        { field: 'qty', headerName: t('qty'), flex: 0.7 },
        { field: 'ax_createusername', headerName: t('createdBy'), flex: 0.8 },
        { field: 'ax_createdatetime', headerName: t('createdDateTime'), flex: 0.8 },
    ]

    return (
          <RenderReportData
                columns={columns}
          />
    )
}

const RenderMain = () => {

    return (
          <Box>

              <Grid container spacing={1}>

                  <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                      <RenderFormSearch/>
                  </Grid>

              </Grid>

              <RenderReportDataDisplay/>

          </Box>
    )
}

export default function ReportDeliveryOrderItem({
    routeType
}) {

    const navigate = useNavigate();
    const { getHtmlHead } = useSystemHead(routeType)

    const {
        t,
        formik,
    } = useReportContext()

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.report.id, scopeTypes.report.deliveryItem.id)

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    return (
          <Box>
              {
                  getHtmlHead({ routeType, title: headTitles.deliveryReports })
              }

              <RenderBreadcumbs
                    navigate={navigate}
              />

              {
                  isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                        <RenderMain/>
                        :
                        <CommonRestricted/>
              }

              {/* {JSON.stringify(values)}
            {JSON.stringify(errors)} */}

          </Box>
    )
}